import React from "react"
import ZdqConnectorSetup from "../../components/ZdqConnectorSetup"
import { AWS_RDS_POSTGRES } from "../../Constants"

function ZdqAwsRdsPostgresConnector() {
    return <ZdqConnectorSetup vendor={AWS_RDS_POSTGRES}></ZdqConnectorSetup>
}

export default ZdqAwsRdsPostgresConnector 